module.exports = __webpack_public_path__ + "img/about03.4916eb80.png";